import ApplicationResource from './ApplicationResource';
import asPagedContentSchema from './utils/asPagedContent';
export default class ApplicationPaginatedResource extends ApplicationResource {
  static list() {
    return super.list().extend({
      schema: asPagedContentSchema(this)
    });
  }

  static appendList(newResults, existingResults) {
    var _a; // In case there are duplicates, Set will eliminate them.


    const set = new Set([...((_a = existingResults === null || existingResults === void 0 ? void 0 : existingResults.content) !== null && _a !== void 0 ? _a : []), ...newResults.content]);
    return Object.assign(Object.assign({}, newResults), {
      content: [...set.values()]
    });
  }

}